import { api, createApi } from '../api';
import type {
  WorkflowAuditDetail,
  WorkflowAuditListResponse,
} from '../api/types';

export class AuditService {
  private resolveBaseUrl(baseUrl?: string) {
    return baseUrl ? createApi({ baseUrl }).workflowAudits : api.workflowAudits;
  }

  list(
    baseUrl?: string,
    params?: {
      workflowId?: number;
      status?: string;
      trigger?: string;
      startedFrom?: string;
      search?: string;
      page?: number;
      limit?: number;
    }
  ): Promise<WorkflowAuditListResponse> {
    return this.resolveBaseUrl(baseUrl).list(params);
  }

  get(baseUrl: string | undefined, id: number): Promise<WorkflowAuditDetail> {
    return this.resolveBaseUrl(baseUrl).get(id);
  }
}

export const auditService = new AuditService();
